import { render, staticRenderFns } from "./reporte-condicion-salud-editar .vue?vue&type=template&id=0afc84b6&"
import script from "./reporte-condicion-salud-editar .vue?vue&type=script&lang=js&"
export * from "./reporte-condicion-salud-editar .vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports